import { BaseApiService } from '@/services/base-service';
import { BaseResponse } from '@/types';
import { Videos } from '../types';

interface VideosList extends BaseResponse {
  data: {
    items: Videos.Video[],
  }
}

export class VideosService extends BaseApiService {
  private readonly base_path = 'faq/videos';

  async get_videos(): Promise<VideosList> {
    const { data } = await this.http_client.get<VideosList>(this.base_path);

    return data;
  }
}
